import { observer } from 'mobx-react';
import { Dispatch, SetStateAction } from 'react';
import { T } from '../../../../../../../../Translations';
import clsx from 'clsx';

interface Props {
  description: string;
  onChange: Dispatch<SetStateAction<string>>;
}

function Description({ description, onChange }: Props) {
  return (
    <div className={`mb-6`}>
      <p className="mb-2 text-sm font-semibold text-gray-800">
        <label htmlFor="description">
          <T kind="Description" />
        </label>
      </p>
      <textarea
        id="description"
        autoComplete="off"
        maxLength={255}
        className={clsx('w-full rounded border border-gray-300 py-3 px-4 text-sm')}
        onChange={(e) => onChange(e.target.value)}
        value={description}
        rows={4}
      />
    </div>
  );
}

export default observer(Description);
